import React from "react";
import { HeroUIProvider } from "@heroui/react";
import { AuthProvider } from "./context/AuthContext";
import Routes from "./Routes";

const { initialize } = require('helios-web-sdk');

const App = () => {
  initialize({
    apiToken: process.env.API_TOKEN,
    serviceName: process.env.SERVICE_NAME,
    enable: true,
    environment: process.env.ENVIRONMENT
  });

  return (
    <HeroUIProvider>
      <AuthProvider>
        <Routes />
      </AuthProvider>
    </HeroUIProvider>
  );
};

export default App;